import React, { useState, useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { FiAperture, FiArrowLeft, FiEye, FiEyeOff, FiRefreshCcw, FiRewind, FiRss, FiSave, FiSend, FiServer, FiSettings, FiShield, FiShieldOff, FiShuffle, FiSidebar } from 'react-icons/fi';
import { getSmartInventorySettings, updateSmartInventorySettings, syncInventoryNow } from '../../../api/context/syncInventory/index';
import Loader from "../../../components/loader/loader";
import toast from 'react-hot-toast';
import AsyncSelect from 'react-select/async';
import { getCategoryListingPaginate, getSubCategoryListingPaginate } from '../../../api/context/manufacturer';
import { getBrandListing } from '../../../api/context/brand';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { Modal } from 'react-bootstrap';
import { FiAlertTriangle } from 'react-icons/fi';
import { IoMdArrowBack } from 'react-icons/io';

export default function SmartInventoryPage() {
  const user = JSON.parse(localStorage.getItem('user'))
  const navigate = useNavigate();
  const { id: vendorId } = useParams();
  const [platform, setPlatform] = useState('woocommerce');
  const [formData, setFormData] = useState({
    storeUrl: '',
    clientId: '',
    clientSecret: '',
    consumerKey: '',
    consumerSecret: '',
    syncFrequency: null,
    brandId: '',
    subCategoryId: '',
    subSubCategoryId: '',
    selectedBrand: null,
    selectedCategory: null,
    selectedSubCategory: null
  });
  const [errors, setErrors] = useState({});
  const [showClientId, setShowClientId] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);
  const [showConsumerKey, setShowConsumerKey] = useState(false);
  const [showConsumerSecret, setShowConsumerSecret] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const [showErrorLogs, setShowErrorLogs] = useState(false);
  const [errorLogs, setErrorLogs] = useState([]);

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [hasExistingSettings, setHasExistingSettings] = useState(false);
  const [productStats, setProductStats] = useState({
    totalPublishedProducts: 0,
    totalSyncedProducts: 0,
    isCategoryMappingDone: false,
  });



  // For dropdown options
  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [brands, setBrands] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const typingTimer = useRef(null);
  // const [dropdownsLoading, setDropdownsLoading] = useState({
  //   brands: true,
  //   categories: true,
  //   subcategories: true
  // });

  const formControlStyles = {
    borderRadius: "0 0px 0px 10px",
    border: "1px solid #a7a7a7",
    padding: '8px 16px',
  };


  // Add this style object
  const progressLabelStyle = {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '20px',
    fontWeight: '600',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    cursor: 'default',
    position: 'relative',
    overflow: 'hidden'
  };


  const getProgressColor = (synced, total) => {
    if (total === 0) return '#a0a0a0'; // gray if no products

    const percentage = synced / total;

    // Color progression:
    // 0-30%: Red (#FF3A30) to Orange (#FF8C00)
    // 30-100%: Orange (#FF8C00) to Teal gradient (your colors)

    if (percentage <= 0.3) {
      // Red to Orange transition
      const start = { r: 255, g: 58, b: 48 };  // Red
      const end = { r: 255, g: 140, b: 0 };    // Orange

      const subPercentage = percentage / 0.3;
      const r = Math.floor(start.r + (end.r - start.r) * subPercentage);
      const g = Math.floor(start.g + (end.g - start.g) * subPercentage);
      const b = Math.floor(start.b + (end.b - start.b) * subPercentage);

      return `rgb(${r}, ${g}, ${b})`;
    } else {
      // Orange to Teal gradient (your colors)
      const start = { r: 0, g: 126, b: 169 };    // Orange
      const mid = { r: 0, g: 126, b: 169 };    // Your start teal
      const end = { r: 0, g: 208, b: 187 };    // Your end teal

      // First transition from orange to your start teal (30-65%)
      if (percentage <= 0.65) {
        const subPercentage = (percentage - 0.3) / 0.35;
        const r = Math.floor(start.r + (mid.r - start.r) * subPercentage);
        const g = Math.floor(start.g + (mid.g - start.g) * subPercentage);
        const b = Math.floor(start.b + (mid.b - start.b) * subPercentage);
        return `rgb(${r}, ${g}, ${b})`;
      }
      // Then transition to your end teal (65-100%)
      else {
        const subPercentage = (percentage - 0.65) / 0.35;
        const r = Math.floor(mid.r + (end.r - mid.r) * subPercentage);
        const g = Math.floor(mid.g + (end.g - mid.g) * subPercentage);
        const b = Math.floor(mid.b + (end.b - mid.b) * subPercentage);
        return `rgb(${r}, ${g}, ${b})`;
      }
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const toggleVisibility = (field) => {
    if (field === 'clientId') setShowClientId(prev => !prev);
    if (field === 'clientSecret') setShowClientSecret(prev => !prev);
    if (field === 'consumerKey') setShowConsumerKey(prev => !prev);
    if (field === 'consumerSecret') setShowConsumerSecret(prev => !prev);
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.storeUrl) {
      newErrors.storeUrl = 'Store URL is required';
    } else if (!/^https?:\/\/.+\..+/.test(formData.storeUrl)) {
      newErrors.storeUrl = 'Enter a valid URL';
    }

    if (platform === 'shopify') {
      if (!formData.clientId) newErrors.clientId = 'Client ID is required';
      if (!formData.clientSecret) newErrors.clientSecret = 'Client Secret is required';
    }

    if (platform === 'woocommerce') {
      if (!formData.consumerKey) newErrors.consumerKey = 'Consumer key is required';
      if (!formData.consumerSecret) newErrors.consumerSecret = 'Consumer secret is required';
    }

    // if (!formData.brandId) {
    //   newErrors.brandId = 'Brand is required';
    // }

    // if (!formData.subCategoryId) {
    //   newErrors.subCategoryId = 'Category is required';
    // }

    // if (!formData.subSubCategoryId) {
    //   newErrors.subSubCategoryId = 'Sub-category is required';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Brand related functions
  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer.current);
      typingTimer.current = setTimeout(() => {
        getBrandListing({ page: currentPage, pageSize: limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            if (currentPage === 1) {
              setBrands(results);
            } else {
              setBrands(prev => [...prev, ...results]);
            }

            setHasMore(results.length > 0);
            resolve(results);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };

  const loadOptionsBrands = (inputValue) => {
    return fetchBrands(inputValue, 1);
  };

  const handleMenuScrollToBottom = () => {
    if (hasMore) {
      const nextPage = page + 1;
      fetchBrands(formData.selectedBrand?.label || '', nextPage).then(() => {
        setPage(nextPage);
      });
    }
  };

  const onBrandChange = (selectedOption) => {
    setFormData({
      ...formData,
      brandId: selectedOption ? selectedOption.value : '',
      selectedBrand: selectedOption,
    });
  };

  // Category related functions
  const loadOptionsCategory = (inputValue) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer.current);
      typingTimer.current = setTimeout(() => {
        if (inputValue.length >= 2) {
          getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setCategory(response?.results);
            } else {
              resolve([]);
            }
          });
        } else {
          resolve([]);
          setCategory([]);
          setSubCategory([]);
        }
      }, 300);
    });
  };

  const onCategoryChange = (selectedOption) => {
    setFormData({
      ...formData,
      subCategoryId: selectedOption ? selectedOption.value : '',
      selectedCategory: selectedOption,
      subSubCategoryId: '',
      selectedSubCategory: null,
    });
    setSubCategory([]);
  };

  // Subcategory related functions
  const loadOptionsSubCategory = (inputValue) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer.current);
      typingTimer.current = setTimeout(() => {
        const categoryId = formData.subCategoryId;
        if (inputValue.length >= 2 && categoryId) {
          getSubCategoryListingPaginate({
            page: 1,
            pageSize: 10,
            search: inputValue,
            categoryIds: [categoryId]
          })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setSubCategory(response?.results);
            } else {
              resolve([]);
            }
          });
        } else {
          resolve([]);
          setSubCategory([]);
        }
      }, 300);
    });
  };

  const onSubCategoryChange = (selectedOption) => {
    setFormData({
      ...formData,
      subSubCategoryId: selectedOption ? selectedOption.value : '',
      selectedSubCategory: selectedOption,
    });
  };

  const customNoOptionsMessage = ({ inputValue }) => {
    return inputValue.length < 2
      ? "Please type at least 2 characters"
      : "No options";
  };

  const handleSyncInventory = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');

    if (!validate()) {
      toast.error("Please fill all required fields before syncing");
      return;
    }

    setIsSyncing(true);

    try {
      const payload = {
        vendorId: vendorId,
      };

      syncInventoryNow(payload)((response) => {
        if (response && (response.statusCode === 200 || response.success)) {
          fetchSettings();
          toast.success("Inventory sync initiated successfully!");
        } else {
          toast.error("Failed to initiate inventory sync.");
          setErrorMessage(response?.message || 'Failed to sync inventory');
        }
        setIsSyncing(false);
      });
    } catch (error) {
      console.error('Error syncing inventory:', error);
      setErrorMessage(error.message || 'An error occurred while syncing inventory');
      setIsSyncing(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');

    if (!validate()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        platform,
        vendorId: vendorId,
        storeUrl: formData.storeUrl,
        syncFrequency: formData.syncFrequency,
        // brandId: formData.brandId,
        // subCategoryId: formData.subCategoryId,
        // subSubCategoryId: formData.subSubCategoryId,
        ...(platform === 'shopify'
          ? {
            clientId: formData.clientId,
            clientSecret: formData.clientSecret,
            consumerKey: '',
            consumerSecret: ''
          }
          : {
            consumerKey: formData.consumerKey,
            consumerSecret: formData.consumerSecret,
            clientId: '',
            clientSecret: ''
          })
      };

      updateSmartInventorySettings(payload)((response) => {
        if (response && (response.statusCode === 200 || response.success)) {
          toast.success("Details updated successfully!");
          fetchSettings();
        } else {
          toast.error("Failed to update Smart Inventory settings.");
          setErrorMessage(response?.message || 'Failed to save settings');
        }
        setIsSubmitting(false);
      });
    } catch (error) {
      console.error('Error updating smart inventory settings:', error);
      setErrorMessage(error.message || 'An error occurred while saving settings');
      setIsSubmitting(false);
    }
  };

  const fetchSettings = () => {
    setLoading(true);
    getSmartInventorySettings({ vendorId: vendorId })((response) => {
      try {
        if (response && response.data) {
          const data = response.data;
          const hasSettings = data.storeUrl &&
            ((data.platform === 'shopify' && data.clientId && data.clientSecret) ||
              (data.platform === 'woocommerce' && data.consumerKey && data.consumerSecret));

          setHasExistingSettings(hasSettings);

          if (data.errorLog) {
            try {
              const parsedLogs = JSON.parse(data.errorLog);
              if (parsedLogs.skippedProducts) {
                setErrorLogs(parsedLogs.skippedProducts);
              }
            } catch (e) {
              console.error('Error parsing error logs:', e);
            }
          }
          const newFormData = {
            storeUrl: data.storeUrl || '',
            clientId: data.clientId || '',
            clientSecret: data.clientSecret || '',
            consumerKey: data.consumerKey || '',
            consumerSecret: data.consumerSecret || '',
            syncFrequency: data.syncFrequency || '15min',
            brandId: data.brandId || '',
            subCategoryId: data.subCategoryId || '',
            subSubCategoryId: data.subSubCategoryId || '',
            selectedBrand: null,
            selectedCategory: null,
            selectedSubCategory: null
          };

          setProductStats({
            totalPublishedProducts: data.totalPublishedProducts || 0,
            totalSyncedProducts: data.totalSyncedProducts || 0,
            isCategoryMappingDone: data.isCategoryMappingDone || false
          })

          // Set platform if it exists in response
          if (data.platform) {
            setPlatform(data.platform);
          }

          // First, ensure we have all brands loaded
          const loadBrands = new Promise((resolve) => {
            getBrandListing({ page: 1, pageSize: 100, search: '' })(brandResponse => {
              if (brandResponse?.statusCode === 200) {
                const brandOptions = brandResponse.data.map(item => ({
                  value: item.id,
                  label: item.name,
                }));
                setBrands(brandOptions);
                resolve(brandOptions);
              } else {
                resolve([]);
              }
            });
          });

          // Then handle categories and subcategories
          const loadCategories = new Promise((resolve) => {
            if (data.subCategoryId) {
              getCategoryListingPaginate({ page: 1, limit: 100, search: '' })(categoryResponse => {
                if (categoryResponse?.statusCode == 200) {
                  const categoryOptions = categoryResponse.results;
                  setCategory(categoryOptions);

                  const selectedCategory = categoryOptions.find(c => c.value === data.subCategoryId);
                  if (selectedCategory) {
                    newFormData.selectedCategory = selectedCategory;

                    // Load subcategories for this category
                    getSubCategoryListingPaginate({
                      page: 1,
                      limit: 100,
                      search: '',
                      categoryIds: [data.subCategoryId]
                    })(subCategoryResponse => {
                      if (subCategoryResponse?.statusCode == 200) {
                        const subCategoryOptions = subCategoryResponse.results;
                        setSubCategory(subCategoryOptions);

                        if (data.subSubCategoryId) {
                          const selectedSubCategory = subCategoryOptions.find(s => s.value === data.subSubCategoryId);
                          if (selectedSubCategory) {
                            newFormData.selectedSubCategory = selectedSubCategory;
                          }
                        }
                      }
                      resolve();
                    });
                  } else {
                    resolve();
                  }
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });

          // Wait for both promises to complete
          Promise.all([loadBrands, loadCategories]).then(([brandOptions]) => {
            // Now find and set the selected brand
            if (data.brandId && brandOptions && brandOptions.length > 0) {
              const selectedBrand = brandOptions.find(b => b.value === data.brandId);
              if (selectedBrand) {
                newFormData.selectedBrand = selectedBrand;
              }
            }

            // Finally update the form data
            setFormData(newFormData);
            setLoading(false);
          });
        }
      } catch (error) {
        console.error('Error processing settings:', error);
        setErrorMessage('Error loading settings');
        setLoading(false);
      }
    });
  };


  useEffect(() => {
    fetchSettings();

    // Initial load of all categories and brands (with larger limit)
    getCategoryListingPaginate({ page: 1, limit: 100, search: '' })(response => {
      if (response?.statusCode == 200) {
        setCategory(response?.results);
      }
    });

    getBrandListing({ page: 1, pageSize: 100, search: '' })(response => {
      if (response?.statusCode == 200) {
        setBrands(response?.data?.map(item => ({
          value: item.id,
          label: item.name
        })));
      }
    });
  }, []);

  useEffect(() => {
    if (formData.subCategoryId) {
      getSubCategoryListingPaginate({
        page: 1,
        limit: 10,
        search: '',
        categoryIds: [formData.subCategoryId]
      })(response => {
        if (response?.statusCode == 200) {
          setSubCategory(response?.results);
        }
      });
    }
  }, [formData.subCategoryId]);



  if (loading) {
    return (
      <div>
        <div className="page-header-sticky d-flex align-items-start gap-3">
          <div
            onClick={() => navigate(user?.userType === 'Vendor' ? '/inventory' : '/vendors')}
            style={{
              cursor: 'pointer',
              fontSize: '24px',
              fontWeight: '800',
              display: 'flex',
              alignItems: 'center',
              lineHeight: 1,
              marginTop: '4px',
            }}
          >
            <IoMdArrowBack className='icon' />
          </div>
          <div>
            <h3 className="mb-1 fw-bold">Smart Inventory</h3>
            <p className="text-muted mb-0">
              Connect your store to enable real-time inventory updates
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-center my-5">
          <div style={{ height: "60vh" }}>
            <Loader />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header-sticky d-flex align-items-start justify-content-between flex-wrap gap-3">
        <div className="d-flex align-items-start gap-3">
          <div
            onClick={() => navigate(user?.userType === 'Vendor' ? '/inventory' : '/vendors')}
            style={{
              cursor: 'pointer',
              fontSize: '24px',
              fontWeight: '800',
              display: 'flex',
              alignItems: 'center',
              lineHeight: 1,
              marginTop: '4px',
            }}
          >
            <IoMdArrowBack className='icon' />
          </div>
          <div>
            <h3 className="mb-1 fw-bold">Smart Inventory</h3>
            <p className="text-muted mb-0">
              Connect your store to enable real-time inventory updates
            </p>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <Tooltip title={`Synced Products: ${productStats.totalSyncedProducts} / Published Products: ${productStats.totalPublishedProducts}`} placement="top">
            {productStats.totalPublishedProducts > 0 ? (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: getProgressColor(
                    productStats.totalSyncedProducts,
                    productStats.totalPublishedProducts
                  ),
                  color: '#fff',
                  textShadow: '0 1px 1px rgba(0,0,0,0.1)',
                  minWidth: '100px',
                  fontWeight: '600',
                  fontSize: '14px',
                  height: '30px',
                  borderRadius: '20px',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                {isSyncing ? (
                  <div className="d-flex align-items-center gap-1">
                    <span className="blinking-dot" style={{ animationDelay: '0ms' }} />
                    <span className="blinking-dot" style={{ animationDelay: '150ms' }} />
                    <span className="blinking-dot" style={{ animationDelay: '300ms' }} />
                    <span className="blinking-dot" style={{ animationDelay: '400ms' }} />
                  </div>
                ) : (
                  <span>
                    {productStats.totalSyncedProducts}/{productStats.totalPublishedProducts}
                  </span>
                )}
                <div
                  className="position-absolute top-0 end-0 h-100"
                  style={{
                    backgroundColor: 'rgba(38, 38, 38, 0.2)',
                    width: `${100 - (productStats.totalSyncedProducts / (productStats.totalPublishedProducts || 1)) * 100}%`
                  }}
                />
              </div>
            ) : <span />}
          </Tooltip>

          {errorLogs.length > 0 && (
            <button
              className="btn p-0 border-0 bg-transparent"
              onClick={() => setShowErrorLogs(true)}
              style={{ lineHeight: 1 }}
            >
              <FiAlertTriangle className="text-warning" size={24} />
            </button>
          )}
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row mb-5">
          <div className="col-md-6 mb-3">
            <label className="form-label">Platform</label>
            <select
              style={formControlStyles}
              className="form-select"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
            >
              <option value="shopify">Shopify</option>
              <option value="woocommerce">WooCommerce</option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Store URL</label>
            <input
              type="url"
              className={`form-control ${errors.storeUrl ? 'is-invalid' : ''}`}
              style={formControlStyles}
              placeholder="https://mystore.com"
              name="storeUrl"
              value={formData.storeUrl}
              onChange={handleChange}
              autoComplete="off"
            />
            {errors.storeUrl && <div className="invalid-feedback">{errors.storeUrl}</div>}
          </div>

          {platform === 'shopify' && (<>
            <div className="col-md-6 mb-3">
              <label className="form-label">Client ID</label>
              <div className="input-group">
                <input
                  type={showClientId ? 'text' : 'password'}
                  className={`form-control ${errors.clientId ? 'is-invalid' : ''}`}
                  style={formControlStyles}
                  placeholder="abcd1234..."
                  name="clientId"
                  value={formData.clientId}
                  onChange={handleChange}
                  autoComplete="new-password"
                  data-lpignore="true"
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => toggleVisibility('clientId')}
                >
                  {showClientId ? <FiEye /> : <FiEyeOff />}
                </button>
                {errors.clientId && <div className="invalid-feedback">{errors.clientId}</div>}
              </div>
              <small className="text-muted">This will be securely encrypted</small>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Client Secret</label>
              <div className="input-group">
                <input
                  type={showClientSecret ? 'text' : 'password'}
                  className={`form-control ${errors.clientSecret ? 'is-invalid' : ''}`}
                  style={formControlStyles}
                  placeholder="xyz9876..."
                  name="clientSecret"
                  value={formData.clientSecret}
                  onChange={handleChange}
                  autoComplete="new-password"
                  data-lpignore="true"
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => toggleVisibility('clientSecret')}
                >
                  {showClientSecret ? <FiEye /> : <FiEyeOff />}
                </button>
                {errors.clientSecret && <div className="invalid-feedback">{errors.clientSecret}</div>}
              </div>
              <small className="text-muted">This will be securely encrypted</small>
            </div>
          </>

          )}

          {platform === 'woocommerce' && (
            <>
              <div className="col-md-6 mb-3">
                <label className="form-label">Consumer Key</label>
                <div className="input-group">
                  <input
                    type={showConsumerKey ? 'text' : 'password'}
                    className={`form-control ${errors.consumerKey ? 'is-invalid' : ''}`}
                    style={formControlStyles}
                    placeholder="ck_xxxxxxxxxxxxxxxx"
                    name="consumerKey"
                    value={formData.consumerKey}
                    onChange={handleChange}
                    autoComplete="new-password"
                    data-lpignore="true"
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => toggleVisibility('consumerKey')}
                  >
                    {showConsumerKey ? <FiEye /> : <FiEyeOff />}
                  </button>
                  {errors.consumerKey && <div className="invalid-feedback">{errors.consumerKey}</div>}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Consumer Secret</label>
                <div className="input-group">
                  <input
                    type={showConsumerSecret ? 'text' : 'password'}
                    style={formControlStyles}
                    className={`form-control ${errors.consumerSecret ? 'is-invalid' : ''}`}
                    placeholder="cs_xxxxxxxxxxxxxxxx"
                    name="consumerSecret"
                    value={formData.consumerSecret}
                    onChange={handleChange}
                    autoComplete="new-password"
                    data-lpignore="true"
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => toggleVisibility('consumerSecret')}
                  >
                    {showConsumerSecret ? <FiEye /> : <FiEyeOff />}
                  </button>
                  {errors.consumerSecret && <div className="invalid-feedback">{errors.consumerSecret}</div>}
                </div>
              </div>
            </>
          )}

          {/* New row for brand, category, and subcategory */}
          {/* <div className="col-md-4 mb-3">
            <label className="form-label">Brand</label>
            <AsyncSelect
              loadOptions={loadOptionsBrands}
              defaultOptions={brands}
              classNamePrefix="select"
              isClearable={true}
              placeholder="Search Brands"
              onChange={onBrandChange}
              value={formData.selectedBrand}
              onMenuScrollToBottom={handleMenuScrollToBottom}
              noOptionsMessage={customNoOptionsMessage}
              theme={(theme) => ({
                ...theme,
                padding: '4px 12px',
                borderRadius: "0 10px 10px 10px",
                colors: {
                  ...theme.colors,
                  primary: '#779be1',
                },
              })}
              styles={{
                menu: (baseStyles) => ({
                  ...baseStyles,
                  zIndex: 9999,
                }),
                control: (provided) => ({
                  ...provided,
                  border: "1px solid #a7a7a7",

                  padding: '6px',
                }),
              }}
            />
          </div> */}

          {/* <div className="col-md-4 mb-3">
            <label className="form-label">Category</label>
            <AsyncSelect
              loadOptions={loadOptionsCategory}
              defaultOptions={category}
              classNamePrefix="select"
              isClearable={true}
              placeholder="Search Categories"
              onChange={onCategoryChange}
              value={formData.selectedCategory}
              noOptionsMessage={customNoOptionsMessage}
              theme={(theme) => ({
                ...theme,
                padding: '4px 12px',
                borderRadius: "0 10px 10px 10px",
                colors: {
                  ...theme.colors,
                  primary: '#779be1',
                },
              })}
              styles={{
                menu: (baseStyles) => ({
                  ...baseStyles,
                  zIndex: 9999,
                }),
                control: (provided) => ({
                  ...provided,
                  border: "1px solid #a7a7a7",
                  padding: '6px',
                }),
              }}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">Sub-Category</label>
            <AsyncSelect
              loadOptions={loadOptionsSubCategory}
              defaultOptions={subcategory}
              classNamePrefix="select"
              isClearable={true}
              placeholder="Search Sub Categories"
              onChange={onSubCategoryChange}
              value={formData.selectedSubCategory}
              noOptionsMessage={customNoOptionsMessage}
              isDisabled={!formData.subCategoryId}
              theme={(theme) => ({
                ...theme,
                padding: '4px 12px',
                borderRadius: "0 10px 10px 10px",
                colors: {
                  ...theme.colors,
                  primary: '#779be1',
                },
              })}
              styles={{
                menu: (baseStyles) => ({
                  ...baseStyles,
                  zIndex: 9999,
                }),
                control: (provided) => ({
                  ...provided,
                  border: "1px solid #a7a7a7",
                  padding: '6px',
                }),
              }}
            />
          </div> */}
        </div>

        <div className="d-flex position-fixed bottom-0 mb-4 end-0 mx-4 gap-3">
          <button
            type="submit"
            className="request_btn"
            disabled={isSubmitting || isSyncing}
          >
            {isSubmitting ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                <span className="ms-2">Saving settings...</span>
              </>
            ) : (
              <>
                <FiServer className="text-white" />
                <span className="text-white">Save Sync Settings</span>
              </>
            )}
          </button>
          {(hasExistingSettings && user?.userType === 'ADMIN') && (
            <button
              type="button"
              className="request_btn"
              onClick={() => navigate('/map-category-size/' + vendorId)}
              disabled={isSubmitting || isSyncing}
            >
              {(
                <>
                  <FiShuffle className="text-white" />
                  <span className="text-white">Map Categories</span>
                </>
              )}
            </button>
          )}
          {hasExistingSettings && productStats.isCategoryMappingDone && (
            <button
              type="button"
              className="request_btn"
              onClick={handleSyncInventory}
              disabled={isSubmitting || isSyncing}
            >
              {isSyncing ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  <span className="ms-2">Syncing Inventory...</span>
                </>
              ) : (
                <>
                  <FiRefreshCcw className="text-white" />
                  <span className="text-white">Sync Inventory</span>
                </>
              )}
            </button>
          )}
        </div>
      </form>
      {/* Error Logs Modal */}
      <Modal show={showErrorLogs} onHide={() => setShowErrorLogs(false)} centered>
        <Modal.Header closeButton className="border-0 pb-2">
          <Modal.Title className="d-flex align-items-center gap-2">
            <span className="fs-4 fw-semibold">Sync Issues ({errorLogs.length})</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3 pb-0" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {errorLogs.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-sm mb-0">
                <thead>
                  <tr className="">
                    <th style={{
                      width: '30%',
                      fontWeight: '600',
                      fontSize: '14px',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      borderRight: '1px solid #dee2e6' // Add this line
                    }}>Product ID</th>
                    <th style={{
                      fontWeight: '600',
                      fontSize: '14px',
                      textAlign: 'center',
                      verticalAlign: 'middle'
                    }}>Issues</th>
                  </tr>
                </thead>
                <tbody>
                  {errorLogs.map((error, index) => (
                    <tr key={index} className="border-bottom">
                      <td
                        className="align-middle text-center py-2"
                        style={{ borderRight: '1px solid #dee2e6' }} // Add this line
                      >
                        <strong className="text-black">{error.productId}</strong>
                      </td>
                      <td className="text-muted py-2">
                        <ul className="mb-0 ps-3 small" style={{ listStyleType: 'disc' }}>
                          {error.validationErrors.map((err, i) => (
                            <li key={i} className="py-1">{err}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-3 text-muted">
              <p className="mb-0">No sync issues found</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-2 px-4">
          <button
            className="cancel_btn"
            onClick={() => setShowErrorLogs(false)}
            style={{ minWidth: '80px' }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}